import React from "react"
import '../../Styles/UserPanel/StepsUserForm.css'
import { connect } from "react-redux"
import { withRouter } from 'react-router-dom'
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import { Avatar, Button, Typography, Form, message, Icon, Input, Row, Col, Select, Table, Checkbox, Card, Radio, Spin, InputNumber } from 'antd';
import { Auth, API } from "aws-amplify"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"

const { Title, Paragraph } = Typography;
const { Option } = Select;

var states= [];
var cuota =[];
var montos_maximos=[{key:'A', desde:0, hasta:17345, categoria:'A'},{key:'B', desde:17394, hasta:26092, categoria:'B'},{key:'C', desde:26092, hasta:34789, categoria:'C'},
                    {key:'D', desde:34789, hasta:52184, categoria:'D'},{key:'E', desde:52184, hasta:69579, categoria:'E'},{key:'F', desde:69579, hasta:86974, categoria:'F'},{key:'G', desde:86974, hasta:104369, categoria:'G'},
                    {key:'H', desde:104369, hasta:144957, categoria:'H'}];
var readingCuitData = false


function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}


class StepsUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            cuitVerified: false,
            previous: 0,
            loading_user: true,
            loading_mono:true,
            loading_plans:true,
            userUpdated:false,
            initialPlanId:null,
            initialPlan:null,
            respuesta: false,
            cuota: [],
            monotributos: [],
            otros_impuestos: [],
            user: {
            },
        };
    }

    componentDidMount() {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/users/me',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        this.setState({ user: response, current: response.estado_clave_fiscal==='CREANDO'?12:1, loading_user:false })
                    })
                    .catch(err =>{
                        message.error('Error cargando datos de usuarios')
                        this.props.Logout()
                        this.props.history.push('/login')
                    })
                })
            .catch(err => {
                message.error('Sesion vencida, vuelve a loguearte por favor')
                this.props.Logout()
                this.props.history.push('/login')
            })

            Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/taxes/monotributos',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {

                        let catAtoH = response.monotributos.filter(cat => cat.categoria.length <= 2)
                        for (var i = 0; i < 8; i++) {
                            if (i===0){
                                montos_maximos[0]={key: catAtoH[0].categoria, desde: 0, hasta: parseInt((catAtoH[0].monto_facturacion_maximo/12))}
                            } else{
                                montos_maximos[i]={key: catAtoH[i].categoria, desde: parseInt((catAtoH[i-1].monto_facturacion_maximo/12)) , hasta: parseInt((catAtoH[i].monto_facturacion_maximo/12))}
                            }
                        }
                        let monotributos = catAtoH.map(mono => {
                            mono["key"] = mono["categoria"]
                            return mono
                        })
                        let otros = response.otros.map(otro => {
                            otro["key"] = otro["nombre"]
                            return otro
                        })
                        response["monotributos"] = monotributos
                        response["otros_impuestos"] = otros

                        this.setState({ loading_mono: false, monotributos: response.monotributos, otros_impuestos: response.otros })
                    })

                    .catch(err => console.log(err))
            })

            Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/taxes/planes',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },

                    }
                )
                    .then(response => {

                        let plusMin = response.filter(p => p.plan === 'Plus').sort((a, b) => (a.costo > b.costo) ? -1 : (a.costo < b.costo) ? 1 : 0)
                        let plusMinOtros = plusMin.filter(plan => plan.medio === 'Otros').sort((a, b) => (a.costo > b.costo) ? -1 : (a.costo < b.costo) ? 1 : 0)[0]
                        this.setState({ loading_plans: false})
                        // this.setState({ loading_plans: false, initialPlan: plusMinOtros.plan, initialPlanId: plusMinOtros.planId })

                    })
                    .catch(err => {
                        message.error("Error leyendo planes")

                    })
            })

}


    call_api = () => {

        Auth.currentSession()
            .then(session => {
                API.put(
                    'test',
                    '/root/users/me',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: {
                            // employment_relationship: {
                            //     cuit_empleador: adminLiteSelected ? adminLiteSelected.cuit : null,
                            //     razon_social: adminLiteSelected ? adminLiteSelected.razon_social : null,
                            //     email: adminLiteSelected ? adminLiteSelected.email : null
                            // },
                            cuit: this.state.user.cuit,
                            clave_fiscal: this.state.user.clave_fiscal,
                            cuit_empleador: this.state.user.cuit_empleador,
                            local_comercial: this.state.user.local_comercial, //si no es null, indica m2 del local
                            costo_alquiler: this.state.user.costo_alquiler,
                            tiene_dni: this.state.user.tiene_dni,
                            empleados: this.state.user.empleados,
                            es_monotributista: this.state.user.es_monotributista,
                            tiene_clavefiscal: this.state.user.tiene_clavefiscal,
                            cat_estimada: (this.state.user.plan ==='Aplicaciones'||this.state.user.trabaja_aplicacion)?'A':this.state.user.cat_estimada,
                            cantidad_familiares: this.state.user.cantidad_familiares, //adherentes
                            aportes_sipa: this.state.user.aportes_sipa,
                            direc_sa: this.state.user.direc_sa,
                            tres_ingresos: this.state.user.tres_ingresos,
                            importador: this.state.user.importador,
                            actividad_preliminar: (this.state.user.plan ==='Aplicaciones'|| this.state.user.trabaja_aplicacion)?'Trabaja en Aplicación':this.state.user.actividad_preliminar,
                            tipo_actividad: (this.state.user.plan ==='Aplicaciones'|| this.state.user.trabaja_aplicacion)?'presta_servicios':this.state.user.tipo_actividad,
                            razon_social: this.state.user.razon_social,
                            direccion: this.state.user.direccion,
                            ciudad: this.state.user.ciudad,
                            provincia: this.state.user.provincia,
                            cp: this.state.user.cp,
                            foto_dni_fr:(this.state.user.es_monotributista || this.state.user.foto_dni_fr)?true:false,
                            foto_dni_tr:(this.state.user.es_monotributista || this.state.user.foto_dni_tr)?true:false,
                            foto_rostro:(this.state.user.es_monotributista || this.state.user.foto_rostro)?true:false
                        }
                    }
                )
                    .then(response => {
                        message.success("Valores actualizados correctamente")
                        this.setState({userUpdated:true})
                    })
                    .catch(err => {
                        message.error("Hubo un error actualizando los datos")
                        this.setState({ loading: false })
                    })
            })
    }

    handleSubmit = e => {
        e.preventDefault()
        switch (this.state.current) {

            case 0:
                this.next()
                break;

            case 1:
                this.props.form.validateFields(['es_monotributista'], (err, values) => {
                    if (!err) {
                        this.next()
                    }
                });
                break;

            case 2:
                // this.props.form.validateFields(['trabaja_aplicacion'], (err, values) => {
                //     if (!err) {
                //         this.next()
                //     }
                // });
                break;

            case 3:
                // this.next()
                break;

            case 4:
                //this.next()
                break;

            case 5:
                this.props.form.validateFields(['cuit'], (err, values) => {
                    if (!err) {
                        this.props.form.validateFields(['clave_fiscal'],(error,values)=>{
                            if(!error){
                                this.next()
                            }
                        })
                    }
                });
                break;

            case 6:
                this.props.form.validateFields(['tiene_dni'], (err, values) => {
                    if (!err) {
                        this.next()
                    }
                });
                break;

            case 7:
                this.props.form.validateFields(['tiene_clavefiscal'], (err, values) => {
                    if (!err) {
                        this.next()
                    }
                });
                break;

            case 8:
                // this.props.form.validateFields(['aportes_sipa'], (err, values) => {
                //     if (!err) {
                //         this.next()
                //     }
                // });
                this.props.form.validateFields(['tipo_actividad', 'actividad_preliminar'], (err, values) => {
                    if (!err) {
                        this.next()
                    }
                });
                break;

            case 9:
                this.props.form.validateFields(['tipo_actividad', 'actividad_preliminar'], (err, values) => {
                    if (!err) {
                        this.next()
                    }
                });
                break;

            case 10:
                this.next()
                break;

            case 11:
                this.props.form.validateFields(['cantidad_familiares'], (err, values) => {
                    if (!err) {
                        this.next()
                    }
                });
                break;

            case 12: // continuar desde pedir clave fiscal
                this.next()
                break;

            case 13:
                this.next()
                break;

            case 14:
                this.props.form.validateFields(['espacio_fisico'], (err, values) => {
                    if (!err) {
                        this.next()
                    }
                });
                break;

            case 15:
                this.next()
                break;

            case 16:
                // this.props.form.validateFields(['local_comercial', 'costo_alquiler'], (err, values) => {
                //     if (!err) {
                //         this.next()
                //     }
                // });
                this.next()
                break;

            case 17:
                // this.props.form.validateFields(['cat_estimada'], (err, values) => {
                //     if (!err) {
                //         this.next()
                //     }
                // });
                this.next()
                break;

            case 18:
                this.next()
                break;

            case 19:
                // this.props.form.validateFields(['empleados'], (err, values) => {
                //     if (!err) {
                //         this.next()
                //     }
                // });
                this.next()
                break;

            case 20:
                // this.props.form.validateFields(['tres_ingresos', 'direc_sa', 'importador'], (err, values) => {
                //     if (!err) {
                //         this.next()
                //     }
                // });
                this.next()
                break;

            case 21:
                // this.props.form.validateFields(['cuit_empleador'], (err, values) => {
                //     if (!err) {
                //         this.next()
                //     }
                // });
                this.next()
                break;

            case 22:
                this.next()
                break;

            case 23:
                this.next()
                break;

            default:
                this.next()

        }


    };


    next() {
        if (this.state.current !== states[states.length - 1]) {
            states.push(this.state.current)
        }
        const new_data = { ...this.state.user }

        switch (this.state.current) {
            case 0:
                message.error('Error en flujo - case: 0')
                this.setState({ current: 1 })
                break;

            case 1:
                //Eres monotributista
                if (this.state.user.es_monotributista === true) {
                    //a pedir cuit y clave fiscal
                    this.setState({ current: 5 })
                    break;
                }
                else {
                    //a preg si tiene dni
                    this.setState({current:6})
                    break;
                }

            case 2:
                message.error('Error en flujo - case: 2')
                //elije tu plan
                // if (this.state.user.es_monotributista === true && this.state.trabajaEnAplicacion === false) {
                //     // 30 dias gratis y a pedir clave fiscal y cuit
                //     new_data['plan_id'] = this.state.initialPlanId
                //     new_data['plan'] = this.state.initialPlan
                //     this.setState({ current: 5, user: new_data })
                //     return;
                // }
                // else if (this.state.user.es_monotributista === false && this.state.trabajaEnAplicacion === true) {
                //     new_data["tipo_actividad"] = 'presta_servicios';
                //     new_data['actividad_preliminar'] = 'Trabajo en pedidos Ya'
                //     new_data['cat_estimada'] = 'A'
                //     new_data['plan']='Aplicaciones'
                //     this.setState({ current: 3, user: new_data })
                //     return;
                // }
                // else {
                //     this.props.UserDataLoad(this.state.user)
                //     this.setState({ current: 3 })
                //     return;
                // }
                break;

            case 3:
                message.error('Error en flujo - case: 3')
                //pantalla de seleccion de plan
                // if (this.state.user.es_monotributista === true) {
                //     //a pedir cuit y clave fiscal
                //     this.setState({ current: 5 })
                //     return;
                // }
                // else if (this.state.user.es_monotributista === false) {
                //     //a preg si tiene dni
                //     this.setState({ current: 6 })
                //     return;
                // }
                break;

            case 4:
                message.error('Error en flujo - case: 4')
                //pantalla de pago
                //this.setState({ current: 6 })
                break;

            case 5:
                //ingresa cuit y clave fiscal
                if (this.state.user.es_monotributista === false) {
                    if (this.state.user.trabaja_aplicacion === false) {
                        this.setState({ current: 8 }) // Actividades
                    } else {
                        this.composicion_cuota()
                        this.setState({ current: 16 }) //Cuota mensual
                        this.call_api()
                    }
                    return;
                }
                else if (this.state.user.es_monotributista === true) {
                   // if (this.state.user.trabaja_aplicacion === false) {
                        //this.composicion_cuota()
                        this.setState({ current: 15 }) // Fin Monotributo
                        this.call_api()
                    //} else {
                    //    this.setState({ current: 15 }) // Actividades
                    //}
                    return;
                }
                break;

            case 6:
                // tiene dni?
                if (!this.state.user.tiene_dni) {
                    this.setState({ user: new_data, current: 10 })
                    this.call_api()
                    return;
                }
                else if (this.state.user.tiene_dni) {
                    //new_data["tiene_dni"] = true
                    this.setState({ current: 7/*, user: new_data*/ })
                    return;
                }
                break;

            case 7:
                //tiene clave fiscal/cuit
                if (!this.state.user.tiene_clavefiscal) {
                    this.setState({ user: new_data, current: 10 })
                    this.call_api()
                    return;
                }
                else if (this.state.user.tiene_clavefiscal) {
                    this.setState({ current: 5 })
                    return;
                }
                break;
                
            case 8: //antes 9
                //Selecciona actividad
                this.composicion_cuota()
                this.setState({ current: 16 }) // composicion cuota
                this.call_api()
                break;

            case 10:
                //fin sin dni
                this.setState({ current: 0 })
                break;

            case 11:
                //fin sin clave fiscal
                this.setState({ current: 0 })
                break;

            case 12:
                // //desea incorporar familiares a su obra social?
                // this.setState({ current: 13 })
                // this.updateCuota()
                //Bienvenido de nuevo
                this.setState({ current: 5 })
                break;

            case 13:
                //muestra resultados
                this.setState({ current: 22 })
                this.call_api()
                break;

            case 14:
                //dispone de espacio p/ atencion al publico?
                /*
                if (this.state.respuesta) {
                    this.setState({ current: 16 })
                    return;
                }
                else if (!this.state.respuesta) {
                    this.setState({ current: 17 })
                    return;
                }
                */
               this.setState({ current : 5})
                break;

            case 15:
                //Bienvenido de nuevo
                this.setState({ current: 5 })
                break;

            case 16:
                this.setState({ current: 14 }) // fin no mono
                break;

            case 17:
                //Monto de facturacion esperada
                if (this.state.user.cat_estimada === 'RI') {
                    this.setState({ current: 18 })
                    break;
                } else {
                    this.setState({ current: 19 })
                    break;
                }

            case 18:
                //No puedes ser monotributista
                this.setState({ current: 22 })
                this.call_api()
                break;

            case 19:
                //tienes empleados
                this.setState({ current: 20 })
                break;

            case 20:
                //DDJJ
                if (this.state.user.direc_sa === true || this.state.user.tres_ingresos === true || this.state.user.importador === true) {
                    this.setState({ current: 18 })
                    break;
                }
                else {
                    this.setState({ current: 8 })
                    break;
                }

            case 21:
                //ingreso cuit empleador
                this.updateCuota();
                this.setState({ current: 13 })
                break;

            default:
                message.error('Error en flujo - Case: default')
                const add = this.state.current + 1
                this.setState({ current: add })
                break;

        }
    }

    composicion_cuota = () => {
        cuota = new Array()
        const os = {
            componente: 'Obra Social',
            monto: '$ 1775,18',
            key: 'os1persona'
        }
        const categoriaA = {
            componente: 'Impuesto Integrado (IVA + Imp. Ganancias)',
            monto: '$ 288,07',
            key: 'categoriaA'
        }
        const aportesSipa = {
            componente: 'Autónomo (Jubilación)',
            monto: '$ 1270,99',
            key: 'aportesSipa'
        }
        const total = {
            componente: 'Total',
            monto: '$ 3334,24',
            key: 'total'
        }
        cuota.push(os)
        cuota.push(categoriaA)
        cuota.push(aportesSipa)
        cuota.push(total)
        return cuota
    }

    updateCuota() {

        let valores_cat = []
        cuota.length = 0;
        let aportes_os = this.state.otros_impuestos.filter(otros => otros.key === 'aporte_OS')[0].valor

        if (this.state.user.cat_estimada === '' || this.state.user.cat_estimada === null) {
            valores_cat = this.state.monotributos.filter(mono => mono.key === 'A')[0]
        } else {
            valores_cat = this.state.monotributos.filter(mono => mono.key === this.state.user.cat_estimada)[0]
        }

        let os = null;
        let sipa = null;
        let aporte_actividad = null;

        aporte_actividad = this.state.user.tipo_actividad === "presta_servicios" ? valores_cat.impuesto_servicios : valores_cat.impuesto_bienes
        sipa = (this.state.user.tipo_actividad === "alquileres" || this.state.user.aportes_sipa === true) ? 0 : valores_cat.aportes_sipa
        os = this.state.user.aportes_sipa === true ? 0 : aportes_os * (valores_cat.porcentaje_os / 100) * (1 + ((this.state.user.cantidad_familiares === null || this.state.user.cantidad_familiares === undefined) ? 0 : parseInt(this.state.user.cantidad_familiares)))

        let obra_social = {
            componente: 'Obra Social',
            monto: '$ ' + os,
            key: 'obra_social'
        };
        let impuesto_integrado = {
            componente: 'Impuesto Integrado (IVA + Imp. Ganancias)',
            monto: '$ ' + aporte_actividad,
            key: 'impuesto_integrado'
        };
        let autonomo = {
            componente: 'Autónomo (Jubilación)',
            monto: '$ ' + sipa,
            key: 'autonomo'
        };
        let total = {
            componente: 'Total (*)',
            monto: '$ ' + parseInt(os + sipa + aporte_actividad),
            key: 'total'
        }
        cuota.push(obra_social)
        cuota.push(impuesto_integrado)
        cuota.push(autonomo)
        cuota.push(total)
    }

    checkBoxChange(value) {
        const user = { ...this.state.user }
        if (user[value] === true) {
            user[value] = false
            this.setState({ user: user })
            return;
        }
        else {
            user[value] = true
            this.setState({ user: user })
            return;
        }
    }

    prev() {
        if (states === undefined) {
            const previous = this.state.current - 1
            this.setState({ current: previous })
        } else {
            const previous = states.pop()
            this.setState({ current: previous });
        }
    }

    updateData(field, value) {
        const user = { ...this.state.user }
        if (field === 'cuit' && value !== null){
            user['cuit']=value.toString().replace(/\W/g, "")
            this.setState({ user: user })
        } else{
            user[field] = value
            this.setState({ user: user })
        }
    }

    cuitData() {
        message.config({ maxCount: 1 })
        message
            .loading('Verificando CUIT...', 10)
        Auth.currentSession()
            .then(session => {
                API.get(
                    'test',
                    '/contribuyente',
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        queryStringParameters: {
                            cuit: this.state.user.cuit
                        }
                    }
                )
                
                    .then(response => {
                        readingCuitData = false;
                        this.setState({ cuitVerified: true })
                        message.success('Cuit verificado!')
                        let razon_social = response["razonSocial"]?response["razonSocial"]:""
                        let direccion = response["Direccion"]?response["Direccion"]:""
                        let ciudad = response['Localidad']?response['Localidad']:""
                        let provincia = response['Provincia']?response['Provincia']:""
                        let cp = response['Codigo Postal']?response['Codigo Postal']:""
                        this.updateData("direccion", direccion)
                        this.updateData("cp", cp)
                        this.updateData("razon_social", razon_social)
                        this.updateData('provincia', provincia)
                        this.updateData('ciudad', ciudad)
                    })
                    .catch(err => {
                        readingCuitData = false
                        message.success("Cuit valido! ")
                        this.setState({cuitVerified:true})
                    })
            })
        .catch(err=>{
            message.error('Error de comunicacion con AFIP')
            readingCuitData = false
            this.setState({cuitVerified:true})
        })
    }

    render() {

        if (this.state.loading_mono||this.state.lading_user||this.state.loading_plans) {
            return (
                <>
                <Row></Row>
                <Row type="flex" justify="space-around" align="middle" style={{marginTop:'150px'}}>
                    <Col style={{minHeight:'360px'}}>
                        <Spin indicator={CustomSpinner}/>
                    </Col>
                </Row>
                <Row></Row>
                </>)
        }
        else {

            const noNullValidator = (rule, value, callback) => {
                if (value === undefined || value === null) {
                    callback("Seleccione una opcion")
                }
                else {
                    callback()
                }
            }

            const activityValidator = (rule, value, callback) => {
                if (value === undefined || value === null || value === '') {
                    callback("Seleccione una opcion")
                }
                else {
                    callback()
                }
            }

            const cuitValidator = (rule, value, callback) => {

                if (rule.required === true) {
                    if (typeof(value) === 'undefined' || value === null || value === '') {
                        this.setState({cuitVerified:false})
                        callback('CUIT requerido')
                    }

                    value = value.toString().replace(/\W/g, "");
                    if (value === '') {
                        this.setState({cuitVerified:false})
                        callback('CUIT requerido')
                    }
                    else if (value.length !== 11) {
                        this.setState({cuitVerified:false})
                        callback('El cuit debe tener 11 numeros')
                    }
                    else {
                        var mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                        var total = 0;
                        for (var i = 0; i < mult.length; i++) {
                            total += parseInt(value[i]) * mult[i];
                        }
                        var mod = total % 11;
                        var digito = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;
                    }
                    if (digito === parseInt(value[10])) {
                        /*if (this.state.cuitVerified===false){
                            readingCuitData = true
                            this.cuitData()
                       }*/
                       this.setState({cuitVerified: true})
                       callback()

                    } else {
                        this.setState({cuitVerified:false})
                        callback('CUIT invalido')
                    }
                }
                else {
                    if (typeof (value) === 'undefined' || value === null || value === '') {
                        callback()
                    }
                    value = value.toString().replace(/\W/g, "");
                    if (value.length !== 11) {
                        callback('El cuit debe tener 11 numeros')
                    }
                    else {
                         mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                         total = 0;
                        for ( i = 0; i < mult.length; i++) {
                            total += parseInt(value[i]) * mult[i];
                        }
                         mod = total % 11;
                         digito = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;
                    }
                    if (digito === parseInt(value[10])) {
                        callback()
                    } else {
                        callback('CUIT invalido')
                    }
                }

            }

            const positiveNumberValidator = (rule, value, callback) => {
                if (value > 0) {
                    callback()
                }
                else {
                    callback("Numero positivo necesario")
                }
            }
            const columns = [
                {
                    title: "Componente",
                    dataIndex: "componente",
                    key: "componente",
                    width: "50%",
                    align: 'left'
                },
                {
                    title: "Monto",
                    dataIndex: "monto",
                    key: "monto",
                    width: "50%",
                    align: 'center'
                }
            ]
            



            const { getFieldDecorator, getFieldsError } = this.props.form;

            const steps = [
                {   //0
                    title: 'Bienvenido',
                    icon: 'user',
                    content:
                    <div>

                    </div>
                },
                {   //1
                    title: 'Monotributo',
                    icon: 'user',
                    content:

                        <Card>
                            <Col >
                                <Paragraph className="ant-typography-stepsuser">¿Actualmente sos Monotributista?</Paragraph>
                                <Form.Item >
                                    {getFieldDecorator('es_monotributista', {
                                        rules: [{
                                            required: true,
                                            message: 'Selecciona una opcion',
                                            type: 'boolean',
                                            initialValue: null,
                                            validator: noNullValidator
                                        }],
                                    })(
                                        <Radio.Group style={{ margintop: 10, color: '#4c9fdc', paddingRight: "20px", paddingLeft: "20px" }} buttonStyle={'solid'}
                                            onChange={(e) => this.updateData("es_monotributista", e.target.value)}>
                                            <Radio.Button value={true}>Si</Radio.Button>
                                            <Radio.Button value={false}>No</Radio.Button>
                                        </Radio.Group>,
                                    )}
                                </Form.Item>
                            </Col>
                        </Card>


                },
                {   //2
                    title: 'Donde trabajas',
                    content:
                        <div>
                        </div>

                },
                {   //3
                    title: 'Seleccion de Plan',
                    content:
                        <div style={{ width: "100%" }}>
                        </div>
                },
                {   //4
                    title: 'Pantalla de pago',
                    content:
                        <div style={{ width: "100%" }}>
                        </div>

                },
                {   //5
                    title: 'Datos impositivos',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">Por favor, ingresa tu <b>CUIT</b> y <b>clave fiscal</b></Paragraph>

                            <Col>
                                <Form.Item>
                                    {
                                        getFieldDecorator('cuit', {
                                            rules: [
                                                {
                                                    required: true,
                                                    validator: cuitValidator
                                                },
                                            ],
                                        })(<Input
                                            prefix={<Icon type="user" />}
                                            placeholder="CUIT sin espacios ni guiones"
                                            onChange={(e) => this.updateData("cuit", e.target.value ? e.target.value : null)}
                                        />)
                                    }
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item>
                                    {
                                        getFieldDecorator('clave_fiscal', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Clave fiscal requerida',
                                                    min: 6,
                                                    max: 20
                                                },
                                            ]
                                        })(<Input.Password
                                            prefix={<Icon type="lock" />}
                                            type="password"
                                            placeholder="Clave Fiscal"
                                            onChange={(e) => this.updateData( "clave_fiscal", e.target.value ? e.target.value : null)}
                                        />)
                                    }
                                </Form.Item>
                            </Col>
                            <Paragraph style={{ fontSize: '14px' }}>No te preocupes, tus datos son confidenciales</Paragraph>
                        </Card>
                },
                {   //6
                    title: 'DNI ARGENTINO',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">¿Tenés documento de identidad Argentino (DNI) vigente?</Paragraph>
                            <Form.Item >
                                {getFieldDecorator('tiene_dni', {
                                    rules: [{
                                        required: true,
                                        message: 'Selecciona una opcion',
                                        type: 'boolean',
                                        initialValue: null,
                                        validator: noNullValidator
                                    }],
                                })(
                                    <Radio.Group style={{ margintop: 10, color: '#4c9fdc', paddingRight: "20px", paddingLeft: "20px" }} buttonStyle={'solid'} name="tiene_dni"
                                        onChange={(e) => this.updateData("tiene_dni", e.target.value)}
                                    >
                                        <Radio.Button value={true}>Si</Radio.Button>
                                        <Radio.Button value={false}>No</Radio.Button>

                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Card>
                },
                {   //7
                    title: 'Cuit y Clave fiscal',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">¿Tenés CUIT y Clave fiscal? </Paragraph>
                            <Form.Item >
                                {getFieldDecorator('tiene_clavefiscal', {
                                    rules: [{
                                        required: true,
                                        message: 'Selecciona una opcion',
                                        type: 'boolean',
                                        initialValue: null,
                                        validator: noNullValidator
                                    }],
                                })(
                                    <Radio.Group style={{ margintop: 10, color: '#4c9fdc', paddingRight: "20px", paddingLeft: "20px" }} buttonStyle={'solid'} name="tiene_clavefiscal"
                                        onChange={(e) => this.updateData("tiene_clavefiscal", e.target.value)}
                                    >
                                        <Radio.Button value={true}>Si</Radio.Button>
                                        <Radio.Button value={false}>No</Radio.Button>

                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Card>
                },
                {   //8
                    title: 'Tus actividades',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">¿Qué tipo de actividad realizás? </Paragraph>
                            <Form.Item>
                                {
                                    getFieldDecorator('tipo_actividad', {
                                        rules: [{
                                            required: true,
                                            message: 'Selecciona el tipo de actividad que realizas',
                                            validator: activityValidator
                                        }],
                                    })(
                                        <Select
                                            placeholder="Actividades"
                                            onChange={(value) => this.updateData("tipo_actividad", value)}
                                        >
                                            <Option value="presta_servicios">Presto Servicios</Option>
                                            <Option value="vende_mercaderia">Vendo mercaderia</Option>
                                            <Option value="alquileres">Alquilo inmuebles y/o máquinas</Option>
                                        </Select>)}
                            </Form.Item>

                            <Form.Item>
                                {getFieldDecorator('actividad_preliminar', {
                                    rules: [{
                                        required: true,
                                        message: 'Describe tu actividad',
                                        validator: activityValidator
                                    }],
                                })(
                                    <Input
                                        placeholder="Describe brevemente tu actividad"
                                        onChange={(e) => this.updateData("actividad_preliminar", e.target.value ? e.target.value : null)}
                                    />)}
                            </Form.Item>
                        </Card>
                },
                {   //9
                    title: 'Fin sin dni',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">Te enviamos un mail con los pasos a seguir para tu alta de CUIT</Paragraph>
                            <Paragraph className="ant-typography-stepsuser">Podras continuar el proceso cuando tengas tu CUIT.</Paragraph>
                            <Paragraph className="ant-typography-stepsuser">Te esperamos!</Paragraph>
                            
                        </Card>
                },
                {   //10
                    title: 'Fin sin clave fiscal',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">Te enviamos un mail con el instructivo para obtener tu Clave fiscal</Paragraph>
                            <Paragraph className="ant-typography-stepsuser">Una vez que termines con ello, podrás retomar tu alta. </Paragraph>
                            <Paragraph className="ant-typography-stepsuser">Te esperamos!</Paragraph>
                            
                        </Card>
                },
                {   //Antes 12 - 11 TODO Se visualiza solo con el codigo de activacion
                    title: 'Obra Social',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">¿Querés incorporar familiares a tu obra social? El costo por persona es de $ {this.state.otros_impuestos.find(imp=>imp.key ==='aporte_OS').valor}</Paragraph>
                            <Paragraph className="ant-typography-stepsuser"> Si es asi, por favor indicá cuantos.</Paragraph>
                            <Paragraph className="ant-typography-stepsuser">Caso contrario, presiona <b>continuar</b> </Paragraph>
                            <Form.Item>
                                {
                                    getFieldDecorator('cantidad_familiares', {
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ]
                                    })(<InputNumber
                                        style={{ width: 240 }}
                                        placeholder="Cantidad Familiares"
                                        onChange={(e) => this.updateData("cantidad_familiares", e ? e : null)}
                                    />)
                                }
                            </Form.Item>
                        </Card>
                },
                {   //Antes 15 - Ahora 12
                    title: 'Bienvenido nuevamente',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser"><b>¡Bienvenido de nuevo!</b></Paragraph>
                            <Paragraph className="ant-typography-stepsuser">Esperamos que hayas podido generar tu CUIT y Clave Fiscal correctamente.</Paragraph>
                        </Card>
                },
                {   //Antes 18 - Ahora 13
                    title: 'No puedes ser Monotributista',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">Debido a tus respuestas, no puedes encuadrarte dentro del régimen <b>Monotributo</b> </Paragraph>
                            <Paragraph className="ant-typography-stepsuser">Si te quedan dudas, comunicate con nosotros.</Paragraph>
                        </Card>
                },
                { //Antes 22 - Ahora 14 fin no mono
                    title: 'Finalizar',
                    icon: 'check',
                    content:
                        <Row gutter={12}>
                            <Col>
                                <Avatar size={120} icon="check" />
                                <Title level={3}>¡Felicitaciones!</Title>
                                <Paragraph className="ant-typography-stepsuser">Haz completado tu registro.</Paragraph>
                                <Paragraph className="ant-typography-stepsuser">Solo te resta cargar unas fotos tuyas y de tu DNI, haz click en finalizar para continuar.</Paragraph>
                                <Paragraph className="ant-typography-stepsuser"><b>¡Gracias por elegirnos!</b></Paragraph>
                            </Col>
                        </Row>
                },
                { //Antes 23 - Ahora 15 fin mono
                    title: 'Finalizar',
                    icon: 'check',
                    content:
                        <Row gutter={12}>
                            <Col>
                                <Avatar size={120} icon="check" />
                                <Title level={3}>¡Felicitaciones!</Title>
                                <Paragraph className="ant-typography-stepsuser">Haz completado tu registro.</Paragraph>
                                <Paragraph className="ant-typography-stepsuser">Tu alta ya está en proceso, te notificaremos cuando se encuentre listo tu perfil.</Paragraph>
                                <Paragraph className="ant-typography-stepsuser"><b>¡Gracias por elegirnos!</b></Paragraph>
                            </Col>
                        </Row>
                },
                { //Antes 13 - Ahora 16
                    title: 'Tus resultados',
                    content:
                        <Card>
                            <Paragraph className="ant-typography-stepsuser">Composición de tu cuota mensual</Paragraph>
                            <Table
                                columns={columns}
                                dataSource={cuota}
                                pagination={false}>
                            </Table>
                            <Paragraph style={{marginTop:5, marginBottom:5}}>El cálculo de tu cuota puede variar dependiendo de la provincia donde residas o contas con un empleo registrado. Si tenés dudas podés escribirnos a nuestro whatsapp  y te ayudamos a resolverlas.</Paragraph>
                        </Card>
                }
            ];

            const { current } = this.state;
            return (

                <Form onSubmit={this.handleSubmit}>
                    <Row type="flex" justify="space-around" align="middle" style={{ minHeight: "50vh" }}>
                        {steps[current].content}
                    </Row>
                    <Button style={{float:'left'}} onClick={(e) => {
                            this.props.Logout()
                            this.props.history.push('/login')}} >
                            <Icon type="home" />
                        </Button>
                    {current > 0 && current !== 3 && current !== 4 && current !==1 && (
                        <Button className="ant-btn-stepsuser" type="primary" style={{ marginRight: 8 }} disabled={this.statecurrent === 15} onClick={() => this.prev()}>
                            Volver
                        </Button>
                    )}
                    {current === 1 && this.props.goBackToPayment && (
                        <Button className="ant-btn-stepsuser" type="primary" style={{ marginRight: 8 }} disabled={this.statecurrent === 15} onClick={() => this.props.history.push('/initial-plan/2')}>
                            Volver
                        </Button>
                    )}
                    {current < steps.length && current !== 15 && current !== 14 && current !== 3 && current !== 4 && current !== 10 && current !== 11 && (
                        <Button className="ant-btn-stepsuser" type="primary" htmlType="submit" disabled={hasErrors(getFieldsError()) || readingCuitData}>
                            Continuar
                        </Button>
                    )}
                    {((current === steps.length - 2) || current === steps.length -3 || current === 10 || current === 11) && (
                        <Button
                            type="primary"
                            loading={!this.state.userUpdated}
                            className="ant-btn-stepsuser"
                            onClick={() => (current===10 || current===11)?this.props.Logout():this.props.history.push('/')}
                        >
                            Finalizar
                        </Button>
                    )}
                </Form>

            );
        }
    }

}

const StepsUserForm = Form.create({ name: 'steps-user' })(StepsUser);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter((StepsUserForm)));
